"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskListAnomalyTypes = exports.TaskListTypes = exports.PunchType = void 0;
var PunchType;
(function (PunchType) {
    PunchType["in"] = "in";
    PunchType["out"] = "out";
    PunchType["missed"] = "missed_punch";
    PunchType["pending"] = "pending";
})(PunchType = exports.PunchType || (exports.PunchType = {}));
var TaskListTypes;
(function (TaskListTypes) {
    TaskListTypes["RequireAttention"] = "requireAttention";
    TaskListTypes["PendingRequest"] = "pendingRequest";
    TaskListTypes["CompletedRequest"] = "completedRequest";
})(TaskListTypes = exports.TaskListTypes || (exports.TaskListTypes = {}));
var TaskListAnomalyTypes;
(function (TaskListAnomalyTypes) {
    TaskListAnomalyTypes["MissingPunch"] = "missingPunch";
    TaskListAnomalyTypes["DuplicatePunch"] = "duplicatedPunch";
    TaskListAnomalyTypes["SystemAddedPunch"] = "systemAddedPunch";
})(TaskListAnomalyTypes = exports.TaskListAnomalyTypes || (exports.TaskListAnomalyTypes = {}));
